import { render } from "./verify-points.vue?vue&type=template&id=00127d48&scoped=true"
import script from "./verify-points.vue?vue&type=script&lang=js"
export * from "./verify-points.vue?vue&type=script&lang=js"

import "./verify-points.vue?vue&type=style&index=0&id=00127d48&scoped=true&lang=css"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00127d48"]])

export default __exports__